import { internal, template, HoverMixin } from '../../vendor/elix.js';
import eventPath from '../../edge-browser-support/event-path.js';
import { ReactiveElement } from '../../vendor/elix.js';
import toggleAttributeEdge from '../../edge-browser-support/toggle-attribute.js';


class TpMenuEdge extends HoverMixin(ReactiveElement) {
  get sourceButton() {
    return this.shadowRoot.querySelector('#source');
  }

  static get observedAttributes() {
    return [
      ...super.observedAttributes,
      'active',
      'buttontext',
      'hoveractivation'
    ];
  }

  get active() {
    return this[internal.state].active;
  }

  set active(v) {
    this[internal.setState]({ active: v });
  }

  get buttontext() {
    return this[internal.state].buttontext;
  }

  set buttontext(v) {
    this[internal.setState]({ buttontext: v });
  }

  get activeItem() {
    return this[internal.state].activeItem;
  }

  set activeItem(v) {
    this[internal.setState]({ activeItem: v });
  }

  get hoveractivation() {
    return this[internal.state].hoveractivation;
  }

  set hoveractivation(value) {
    this[internal.setState]({ hoveractivation: value });
  }

  get [internal.defaultState]() {
    return Object.assign(super[internal.defaultState], {
      'hoveractivation': true,
      buttontext: null
    });
  }

  attributeChangedCallback(attributeName, oldValue, newValue) {
    super.attributeChangedCallback(attributeName, oldValue, newValue);

    const isTrueString = str => String(str) === 'true';
    const customAttributes = {
      hoveractivation: v => this.hoveractivation = isTrueString(v),
      active: v => this.active = isTrueString(v),
      buttontext: v => this.buttontext = v
    };

    if (Object.keys(customAttributes).includes(attributeName)) {
      customAttributes[attributeName](newValue)
    }
  }

  getItems() {
    return Array.from(this.children)
      .filter(x => !(x.hasAttribute('slot') && x.getAttribute('slot') === 'source'))
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('click', this.documentClick);
  }

  onMenuItemClicked(menuItem) {
    this.activeItem = menuItem;
    this[internal.setState]({ isOpen: false });
    this.dispatchEvent(new CustomEvent('closed', {
      detail: {
        closeResult: menuItem
      }
    }))
  }

  [internal.componentDidMount]() {
    super[internal.componentDidMount]();

    this.activeItem = this.getItems().find(x => x.hasAttribute('active-item'));
    this.sourceButton.addEventListener('click', () => this[internal.setState]({ isOpen: !this[internal.state].isOpen }));
    Array.from(this.shadowRoot.querySelector('#popup-items').children).forEach(menuItem =>
      menuItem.addEventListener('click', (evt) => this.onMenuItemClicked(evt.target))
    );

    this.documentClick = (e) => {
      if (eventPath(e).some(t => t === this)) {
        return;
      }
      this[internal.state].isOpen && this[internal.setState]({ isOpen: false });
    };
    document.addEventListener('click', this.documentClick);

    this[internal.setState]({ isOpen: false });
  }

  [internal.render](changed) {
    super[internal.render](changed);

    if (changed.isOpen) {
      if (this[internal.state].isOpen) {
        this.sourceButton.classList.add('active');
        this.shadowRoot.querySelector('#popup').classList.remove('hidden');
      } else {
        (this.activeItem || this.active)
          ? this.sourceButton.classList.add('active')
          : this.sourceButton.classList.remove('active');
        this.shadowRoot.querySelector('#popup').classList.add('hidden');
      }
    }
    if (changed.activeItem) {
      this.getItems().forEach(e => e.removeAttribute('active-item'));
      this.activeItem.setAttribute('active-item', '');
    }

    if (changed.buttontext) {
      this.sourceButton.textContent = this.buttontext;
    }

    if (changed.hover && this.hoveractivation) {
      if (this[internal.state].hover) {
        setTimeout(() => this[internal.setState]({ isOpen: true }), 0);
      } else if (!this[internal.state].hover) {
        setTimeout(() => this[internal.setState]({ isOpen: false }), 0);
      }
    }
  }

  get [internal.template]() {
    const temp = template.html`
      <span id="source">asd</span>
      <div id="popup-wrapper">
        <div id="popup-container">
          <div class="hidden" id="popup">
              <div id="popup-items">
                  <slot></slot>
              </div>
          </div>
        </div>
      </div>
      <style>
          :host {
            position: relative;
          }
          #source {
              --webkit-font-smoothing: antialiased;
              background: none !important;
              border: 0;
              border-bottom: 2px solid rgba(255, 255, 255, 0);
              color: var(--tp-menu-button-color) !important;
              cursor: pointer;
              display: inline-block;
              font-family: var(--tp-font-subtitle-2-font-family) !important;
              font-size: var(--tp-font-subtitle-2-font-size) !important;
              font-weight: var(--tp-font-subtitle-2-font-weight)!important;
              letter-spacing: var(--tp-font-subtitle-2-letter-spacing)!important;
              line-height: var(--tp-font-subtitle-2-line-height) !important;
              padding: 0 0 2px !important;
              text-transform: var(--tp-font-subtitle-2-text-transform);
          }
          
          #source.active,
          #source:hover {
              border-bottom: 2px solid var(--tp-menu-button-active-border-color);
          }
          
          #popup-items > * {
            --webkit-font-smoothing: antialiased;
            box-sizing: border-box;
            cursor: pointer;
            color: var(--tp-font-body-2-color);
            display: block;
            font-family: var(--tp-font-body-2-font-family);
            font-size: var(--tp-font-body-2-font-size);
            font-weight: var(--tp-font-body-2-font-weight);
            line-height: var(--tp-font-body-2-line-height);
            padding: var(--tp-menu-item-padding) !important;
            text-decoration: none;
            text-align: left;
            width: 100%;
          }
          
          #popup-items > *:hover,
          #popup-items > *:focus,
          #popup-items > *:active,
          #popup-items > *[active-item] {
              background: var(--tp-menu-item-selected-color);
              outline: none;
          }
          
          #popup-items > *[active-item]:hover,
          #popup-items > *[active-item]:active,
          #popup-items > *[active-item]:focus
          {
              background: var(--tp-menu-item-selected-active-item-color) !important;
          }
          
          #popup {
            background: #ffffff;
            border-radius: 3px;
            box-shadow: 0 1px 3px rgba(0,0,0,.33);
            display: table;
            left: -15px;
            margin-top: 15px;
            padding: 6px 0;
            position: relative;
            z-index: 500;
          }
          
          #popup.hidden {
              display: none;
          }
          
          #popup-container {
            margin: 0;
            position: absolute;
          }
          
          #popup-wrapper {
            position: relative;
          }
          
          #container {
              margin: 0;
          }
          
          #popup-items {
              margin: 0;
          }
      </style>
    `;
    return temp;
  }
}

export default TpMenuEdge;
